export const visaApplicationFormConfig = {
  // Form metadata
  metadata: {
    title: "Nouveau Demande de visa (Visa Application)",
    description: "Complete your e-visa application",
    defDossier: 6203,
    environment: 388,
    apiUsername: "API_VISA_USERNAME",
    apiKey: "API_VISA_KEY",
    brandColors: {
      primary: "#003D7A",
      primaryLight: "#0052A3",
      primaryDark: "#002244",
      accent: "#CE1126",
      accentLight: "#FF6B35",
      success: "#FCD116",
      neutral: "#f8f9fa",
      text: "#212529",
      textLight: "#6c757d",
      border: "#e9ecef",
    }
  },

  sections: [
    {
      id: "application-header",
      title: "Application Header",
      order: 1,
      layout: {
        columns: { default: 1, md: 2, lg: 2 },
        gap: "gap-4"
      },
      fields: [
        /*  {
           id: "field-133284",
           name: "133284",
           type: "file",
           label: "Photo d’identité",
           required: true,
           columnSpan: { default: 1, md: 2 },
           validation: {
             required: "This field is required"
           }
         }, */
        {
          id: "field-136534",
          name: "136534",
          type: "date",
          label: "Date",
          required: true,
          columnSpan: { default: 1 },
          validation: {
            required: "This field is required"
          }
        },
        {
          id: "visa-type",
          name: "133301",
          type: "select",
          label: "Type de visa (Visa type)",
          required: true,
          columnSpan: { default: 1 },
          options: [
            { value: "67592", label: "Visa touristique (Tourist visa)" },
            { value: "67593", label: "Visa d'affaires (Business visa)" },
            { value: "67594", label: "Visa de transit (Transit visa)" },
            { value: "67595", label: "Visa de visite familiale (Family visit visa)" },
            { value: "67596", label: "Visa diplomatique (Diplomatic visa)" },
            { value: "67597", label: "Visa officiel (Official/government visa)" },
            { value: "67598", label: "Visa de travail (Work visa)" },
            { value: "67599", label: "Visa d'études (Student visa)" }
          ],
          validation: {
            required: "This field is required"
          }
        }
      ]
    },
    {
      id: "demandeur-info",
      title: "Demandeur (Applicant)",
      order: 2,
      layout: {
        columns: { default: 1, },
        gap: "gap-4"
      },
      linkedContainer: {
        displayId: "133294",
        defdossierId: 6204,
      },
      fields: [
        {
          id: "first-names",
          name: "133214",
          type: "text",
          label: "Prenom(s) (First name(s) / Given names)",
          required: true,
          columnSpan: { default: 1, md: 1 },
          validation: {
            required: "This field is required"
          }
        },
        {
          id: "last-name",
          name: "133218",
          type: "text",
          label: "Nom de famille (Last name / Surname)",
          required: true,
          columnSpan: { default: 1, md: 1 },
          validation: {
            required: "This field is required"
          }
        },
        {
          id: "personal-id",
          name: "133221",
          type: "text",
          label: "Numéro d'identification personnelle (Personal identification number)",
          required: true,
          columnSpan: { default: 1, md: 2, lg: 2 },
          validation: {
            required: "This field is required"
          }
        },
        {
          id: "gender",
          name: "133225",
          type: "select",
          label: "Sexe",
          required: true,
          columnSpan: { default: 1, md: 1, lg: 1 },
          options: [
            { value: 63323, label: "Onbeken" },
            { value: 63322, label: "Vrouw" },
            { value: 63319, label: "Man" }
          ],
          validation: {
            required: "This field is required"
          }
        },
        {
          id: "date-of-birth",
          name: "133226",
          type: "date",
          label: "Date de naissance (Date of birth)",
          required: true,
          columnSpan: { default: 1, md: 1, lg: 1 },
          validation: {
            required: "This field is required"
          }
        },
        {
          id: "city-of-birth",
          name: "133229",
          type: "text",
          label: "Ville de naissance (City of birth)",
          required: true,
          columnSpan: { default: 1, md: 1, lg: 1 },
          validation: {
            required: "This field is required"
          }
        },
        {
          id: "country-of-birth",
          name: "133235",
          type: "linkSelect",
          label: "Pays de naissance (Country of birth)",
          required: true,
          columnSpan: { default: 1, md: 1, lg: 1 },
          validation: {
            required: "This field is required"
          },
          useSearch: true,
          searchField: "summary",
          apiConfig: {
            credentials: {
              username: "API_VISA_USERNAME",
              password: "API_VISA_KEY"
            },
            requestParams: {
              defDossier: 6459,
              limit: 100
            },
            responseMapping: {
              valueField: "id",
              labelField: "summary"
            }
          }
        },
        {
          id: "main-citizenship",
          name: "133236",
          type: "linkSelect",
          label: "Pays de citoyenneté principale (Main citizenship country)",
          required: true,
          columnSpan: { default: 1, md: 1, lg: 1 },
          useSearch: true,
          searchField: "summary",
          validation: {
            required: "This field is required"
          },
          useSearch: true,
          searchField: "summary",
          apiConfig: {
            credentials: {
              username: "API_VISA_USERNAME",
              password: "API_VISA_KEY"
            },
            requestParams: {
              defDossier: 6459,
              limit: 100
            },
            responseMapping: {
              valueField: "id",
              labelField: "summary"
            }
          }
        },
        {
          id: "other-nationality",
          name: "133237",
          type: "select",
          label: "Avez-vous une autre nationalité? (Do you have another nationality?)",
          required: true,
          columnSpan: { default: 1, md: 1, lg: 1 },
          options: [
            { value: 63320, label: "Nee" },
            { value: 63317, label: "Ja" }
          ],
          validation: {
            required: "This field is required"
          }
        },
        {
          id: "marital-status",
          name: "133240",
          type: "select",
          label: "État civil (Marital status)",
          required: true,
          columnSpan: { default: 1, md: 1, lg: 1 },
          options: [
            { value: 67586, label: "Veuf/veuve" },
            { value: 67585, label: "Divorcé(e)" },
            { value: 67584, label: "Marié(e)" },
            { value: 67583, label: "Célibataire" }
          ],
          validation: {
            required: "This field is required"
          }
        },
        {
          id: "profession",
          name: "133241",
          type: "text",
          label: "Profession",
          required: false,
          columnSpan: { default: 1, md: 1, lg: 1 },
          validation: {}
        },
        {
          id: "phone-number",
          name: "133274",
          type: "phone",
          label: "Numéro de téléphone (Phone number)",
          required: true,
          columnSpan: { default: 1, md: 2 },
          validation: {
            required: "This field is required"
          }
        },
        {
          id: "email",
          name: "133276",
          type: "email",
          label: "E-mail",
          required: true,
          columnSpan: { default: 1, md: 2 },
          validation: {
            required: "This field is required",
            pattern: { value: /^\S+@\S+$/i, message: "Invalid email address" }
          }
        },
        {
          id: "demandeur-passport",
          type: "section",
          title: "Passeport",
          order: 1,
          layout: {
            columns: { default: 1 },
            gap: "gap-4"
          },
          linkedContainer: {
            displayId: "133242",
            defdossierId: 6205,
          },
          fields: [
            {
              id: "field-133250",
              name: "133250",
              type: "number",
              label: "Numéro de passeport",
              required: true,
              columnSpan: { default: 4 },
              validation: {
                required: "This field is required"
              }
            },
            {
              id: "main-pays",
              name: "133252",
              type: "linkSelect",
              label: "Pays de délivrance",
              required: true,
              columnSpan: { default: 1, },
              useSearch: true,
              searchField: "summary",
              validation: {
                required: "This field is required"
              },
              useSearch: true,
              searchField: "summary",
              apiConfig: {
                credentials: {
                  username: "API_VISA_USERNAME",
                  password: "API_VISA_KEY"
                },
                requestParams: {
                  defDossier: 6459,
                  limit: 100
                },
                responseMapping: {
                  valueField: "id",
                  labelField: "summary"
                }
              }
            },
            {
              id: "field-133253",
              name: "133253",
              type: "date",
              label: "Date de délivrance",
              required: true,
              columnSpan: { default: 1, },
              validation: {
                required: "This field is required"
              }
            },
            {
              id: "field-133256",
              name: "133256",
              type: "date",
              label: "Date d’expiration",
              required: true,
              columnSpan: { default: 1, },
              validation: {
                required: "This field is required"
              }
            },
            {
              id: "Lieu de délivrance",
              name: "133259",
              type: "text",
              label: "Lieu de délivrance",
              required: true,
              columnSpan: { default: 4, },
              validation: {
                required: "This field is required"
              }
            },
            {
              id: "fild-133278",
              name: "133278",
              type: "file",
              label: "Passeport (Passport)",
              required: true,
              columnSpan: { default: 4, },
              validation: {
                required: "This field is required"
              }
            },
          ]
        },
        {
          id: "Adresse-info",
          title: "Adresse",
          type: "section",
          order: 2,
          layout: {
            columns: { default: 1, },
            gap: "gap-4"
          },
          linkedContainer: {
            displayId: "133304",
            defdossierId: 6206,
          },
          fields: [
            {
              id: "field-133263",
              name: "133263",
              type: "text",
              label: "Adresse (Address)",
              required: true,
              columnSpan: { default: 1, },
              validation: {
                required: "This field is required"
              }
            },
            {
              id: "field-133267",
              name: "133267",
              type: "text",
              label: "Code postal (Zip code)",
              required: true,
              columnSpan: { default: 1, },
              validation: {
                required: "This field is required"
              }
            },
            {
              id: "field-133270",
              name: "133270",
              type: "text",
              label: "Ville ou commune (City or municipality)",
              required: true,
              columnSpan: { default: 1, },
              validation: {
                required: "This field is required"
              }
            },
            {
              id: "field-133271",
              name: "133271",
              type: "text",
              label: "Province / Région (Province / Region)",
              required: true,
              columnSpan: { default: 1, },
              validation: {
                required: "This field is required"
              }
            },
            {
              id: "field-133272",
              name: "133272",
              type: "linkSelect",
              label: "Pays (Country)",
              required: true,
              columnSpan: { default: 1, },
              useSearch: true,
              searchField: "summary",
              validation: {
                required: "This field is required"
              },
              useSearch: true,
              searchField: "summary",
              apiConfig: {
                credentials: {
                  username: "API_VISA_USERNAME",
                  password: "API_VISA_KEY"
                },
                requestParams: {
                  defDossier: 6459,
                  limit: 100
                },
                responseMapping: {
                  valueField: "id",
                  labelField: "summary"
                }
              }
            },
          ]
        }
      ]
    },
  ],

  // Progress tracking configuration
  progress: {
    enabled: false,
    trackRequiredFields: false
  },

  // Auto-save configuration
  autoSave: {
    enabled: false,
    delay: 1000,
    statusMessages: {
      saving: "Saving...",
      saved: "Automatically saved",
      error: "Save failed"
    }
  },

  // Form submission configuration
  submission: {
    showSummary: true,
    summaryFields: [
      { label: "Progress", field: "progress" },
      { label: "Status", field: "status" }
    ],
    submitButton: {
      text: "Submit Application",
      disabledText: "Please fill in all required fields",
      requireAllRequired: true
    }
  },

  // Base styling configuration
  styling: {
    fonts: {
      primary: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      size: {
        small: "12px",
        base: "14px",
        large: "16px"
      }
    },
    spacing: {
      small: "8px",
      base: "12px",
      medium: "16px",
      large: "24px"
    },
    borderRadius: {
      small: "6px",
      base: "8px",
      large: "12px"
    },
    shadows: {
      small: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
      medium: "0 4px 6px -1px",
      large: "0 8px 15px -3px"
    },
    transitions: {
      fast: "all 0.2s ease-in-out",
      medium: "all 0.3s ease-out"
    },

    // Component-specific styles
    index: {
      width: "20px",
      height: "20px",
      fontSize: "14px"
    },
    title: {
      fontWeight: 400,
      fontSize: "18px"
    },
    label: {
      fontSize: "14px",
      fontWeight: "600",
      lineHeight: "1.4",
      marginTop: "0",
      marginBottom: "8px",
      textAlign: "left",
      letterSpacing: "0.025em",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    },
    input: {
      display: "block",
      width: "100%",
      padding: "12px 16px",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "1.5",
      backgroundColor: "#fff",
      backgroundClip: "padding-box",
      border: "1px solid #c3c3c381",
      height: "48px",
      borderRadius: "8px",
      transition: "all 0.2s ease-in-out",
      boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    },
    checkbox: {
      width: "auto",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "1.2",
      border: "none",
      height: "26px",
      borderRadius: "8px",
      transition: "all 0.2s ease-in-out",
      boxShadow: "none",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    },
    radio: {
      width: "auto",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "1.2",
      border: "none",
      height: "26px",
      borderRadius: "8px",
      boxShadow: "none",
    },
    textarea: {
      height: "120px",
      resize: "vertical",
      minHeight: "120px"
    },
    select: {
      control: {
        border: "1px solid #c3c3c381",
        borderRadius: "8px",
        minHeight: "48px",
        boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
      },
      placeholder: {
        color: "#6b7280"
      },
      multiValue: {
        backgroundColor: "#e5e7eb",
        borderRadius: "4px"
      },
      multiValueLabel: {
        color: "#374151",
        fontSize: "14px"
      },
      multiValueRemove: {
        color: "#6b7280",
        ":hover": {
          backgroundColor: "#d1d5db",
          color: "#374151"
        }
      },
      valueContainer: {
        padding: "2px 8px"
      }
    },
    button: {
      background: "linear-gradient(135deg)",
      color: "white",
      fontWeight: "600",
      padding: "12px 24px",
      borderRadius: "8px",
      border: "none",
      fontSize: "14px",
      letterSpacing: "0.025em",
      transition: "all 0.2s ease-in-out",
      boxShadow: "0 4px 6px -1px",
      textTransform: "uppercase"
    }
  }
};

export default visaApplicationFormConfig;
